import { useQueryClient } from '@tanstack/react-query';
import { expensesApi } from '../api/expenses';
import { leavesApi } from '../api/leaves';
import { usersApi } from '../api/users';
import { tasksApi } from '../api/tasks';

export const usePrefetch = () => {
  const queryClient = useQueryClient();

  const prefetchExpenses = () => {
    queryClient.prefetchQuery({
      queryKey: ['expenses'],
      queryFn: () => expensesApi.getExpenseRequests(),
      staleTime: 3 * 60 * 1000,
    });
  };

  const prefetchLeaves = () => {
    queryClient.prefetchQuery({
      queryKey: ['leaves'],
      queryFn: () => leavesApi.getLeaveRequests(),
      staleTime: 3 * 60 * 1000,
    });
  };

  const prefetchUsers = () => {
    queryClient.prefetchQuery({
      queryKey: ['users'],
      queryFn: () => usersApi.getAll(),
      staleTime: 5 * 60 * 1000,
    });
  };

  const prefetchTasks = () => {
    queryClient.prefetchQuery({
      queryKey: ['tasks'],
      queryFn: () => tasksApi.list({}),
      staleTime: 3 * 60 * 1000,
    });
  };

  const prefetchSales = () => {
    // Sales는 mock 데이터이므로 필요 시 구현
    // queryClient.prefetchQuery({
    //   queryKey: ['sales'],
    //   queryFn: () => salesApi.getSales(),
    //   staleTime: 5 * 60 * 1000,
    // });
  };

  const prefetchBooks = () => {
    // Books API가 있다면 여기에 추가
    // queryClient.prefetchQuery({
    //   queryKey: ['books'],
    //   queryFn: () => booksApi.getBooks(),
    //   staleTime: 10 * 60 * 1000,
    // });
  };

  return {
    prefetchExpenses,
    prefetchLeaves,
    prefetchUsers,
    prefetchTasks,
    prefetchSales,
    prefetchBooks,
  };
};